import React from 'react'
import './styles.scss'
import { UserAvatar } from 'components/common'
import { getStaticImage } from 'utils/statics'
import { typeInchat } from 'constants/channels'

const MultiAvatar = ({ users = [], mainWidth = 32, className, type = '',
  conversationPrivate = false, name }) => {

  const widthAndHeight = mainWidth / (users.length >= 2 ? 2 : users.length)
  const classImages = className ? className : ''
  return (
    <div
      className={`multi-avatar-container ${classImages}`}
    >
      {
        typeInchat.includes(type)
          ? <img
            className={`multi-avatar-container__icon-channel-private ${classImages}`}
            src={conversationPrivate ? `${getStaticImage('/icons/orange-brand/icon-channel-private.svg')}`: `${getStaticImage('/icons/orange-brand/icon-channel.svg')}`}
            alt={`${name}`}
            onError={event => {
              event.target.className = 'not-channel-icon'
              event.onerror = null
            }}
          />
          : users.map((user, index) => {
            if( index > 2 ) return null
            return(
              <UserAvatar
                key={user._id + index}
                avatar={user.picture
                  ? user.picture
                  : getStaticImage('/icons/orange-brand/icon-avatar.svg')
                }
                onErrorAvatar={event => {
                  event.target.src = getStaticImage('/icons/orange-brand/icon-avatar.svg')
                  event.onerror = null
                }}
                avatarHeight={widthAndHeight}
                avatarWidth={widthAndHeight}
              />
            )}
          )
      }
    </div>
  )
}

export default MultiAvatar